import Reflux from 'reflux';
import CategoryActions from '../action/categoryActions';

const CategoryStore = Reflux.createStore({
  listenables: CategoryActions,
  onPublishHelper(data) {
    this.trigger(data);
  },
  onPublishTaxonomyData(data) {
    this.trigger(data);
  },
});

export default CategoryStore;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/store/categoryStore.js